import { useId } from "react";
import "./SidePanel.css";

// Six curves from the right edge sweeping down to the bottom-left.
const CURVES = [
  "M600 14 C 520 300, 500 760, 90 945",
  "M600 186 C 545 380, 520 800, 133 955",
  "M600 371 C 560 520, 540 840, 175 965",
  "M600 530 C 560 640, 520 860, 223 980",
  "M600 666 C 540 760, 470 900, 297 990",
  "M600 776 C 540 850, 480 930, 372 995",
];

/** Thin decorative lines on the dark side panel. Purely visual. */
const SidePanelLines = () => {
  const id = useId().replace(/:/g, "");
  return (
    <svg
      className="ds-side-panel__lines"
      viewBox="0 0 600 1000"
      preserveAspectRatio="none"
      aria-hidden="true"
      focusable="false"
    >
      <defs>
        <linearGradient
          id={`fade-${id}`}
          gradientUnits="userSpaceOnUse"
          x1="600"
          y1="0"
          x2="120"
          y2="1000"
        >
          <stop offset="0" stopColor="#fff" stopOpacity="1" />
          <stop offset="0.7" stopColor="#fff" stopOpacity="0.8" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <mask id={`mask-${id}`}>
          <rect width="600" height="1000" fill={`url(#fade-${id})`} />
        </mask>
      </defs>
      <g mask={`url(#mask-${id})`}>
        {CURVES.map((d) => (
          <path key={d} d={d} vectorEffect="non-scaling-stroke" />
        ))}
      </g>
    </svg>
  );
};

export default SidePanelLines;
